import '../../assets/tailwind-compiled.css';
import './LoginComponent.css';

import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useState} from 'react';

import {mainState} from '../../AppMainState';
import logoDark from '../../assets/images/logo_dark.svg';
import {Card} from '../../components/Card';
import {SocialLogin} from '../../components/social-login/SocialLogin';
import {LoginState} from './LoginState';
import buildInfo from '../../buildInfo.json';
import {AppRoutes} from '../../routing/AppRoutes';
import {redirectTo} from '../../routing/browserHistory';

export const LoginComponent: FC = observer(() => {
    const [state] = useState(() => new LoginState());

    if (mainState.currentUser) {
        mainState.signOut();
        return <div/>;
    }

    return <div
        id="login-wrapper"
        className="h-screen max-h-screen blur-overlay flex items-center justify-center px-6 py-5 w-full lg:px-10 lg:py-8"
    >
        <Card className="px-10" footer={
            <div className="">

                <button className="btn btn-primary text-white w-full h-12 mb-3"
                        onClick={() => redirectTo(AppRoutes.Register)}>Register
                </button>
                {/*<LinkButton to={AppRoutes.ForgotPassword}>Forgot password</LinkButton>*/}
            </div>
        }>
            <div className="flex justify-center p-6">
                    <a href="https://www.muscula.com"><img
                        className="w-56"
                        src={logoDark}
                        alt="Muscula logo"
                    /></a>
                </div>

                <form onSubmit={(e) => e.preventDefault()} autoComplete="on">
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            id="username"
                            type="email"
                            autoComplete="username"
                            value={state.email}
                            aria-invalid={state.invalidData}
                            maxLength={64}
                            className={'form-control'}
                            onChange={(e) => state?.setEmail(e.target.value)}
                        />
                        {!state.email && state.invalidData && <div className="invalid-feedback">
                            <div>
                                Email is required
                            </div>
                        </div>}
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            id="password"
                            maxLength={64}
                            value={state.password}
                            aria-invalid={state.invalidData}
                            autoComplete="current-password"
                            className={'form-control'}
                            onChange={(e) => state?.setPassword(e.target.value)}
                        />
                    </div>
                    {state.invalidData && <div className="invalid-feedback">
                        <div>
                            Incorrect email or password. <a className="text-m-green" onClick={e => {
                            e.preventDefault();
                            state?.resetPassword();
                        }} href="#">Reset password</a>
                        </div>
                    </div>
                    }
                    <button className="btn btn-primary mt-2 w-full h-12 " type="submit" onClick={() => state?.signIn()}>
                        {mainState.isLoading && <span className="spinner-border spinner-border-sm mr-1"/>}
                        Sign in with login & password
                    </button>
                </form>
            {!state.isDemoMode && <div className="mt-8 card-footer p-0">

                <div>
                    <SocialLogin state={state} />
                </div>
            </div>}
        </Card>
        <div style={{color: '#545454', position: 'absolute', bottom: 0, right: 0}}>Build
            date: {buildInfo.buildDate}</div>
        </div>;
    },
);
